require('./bootstrap');
require('datatables.net-bs4');
require('leaflet');
require('leaflet.markercluster');
require('beautifymarker/leaflet-beautify-marker-icon');
require('d3');
window.c3 = require('c3');
window.Viewer = require('viewerjs');


$.extend( $.fn.dataTable.defaults, {

	language: {
		"processing": "Procesando...",
		"lengthMenu": "Mostrar _MENU_ registros",
		"zeroRecords": "No se encontraron resultados",
		"emptyTable": "Ningún dato disponible en esta tabla",
		"info": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
		"infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
		"infoFiltered": "(filtrado de un total de _MAX_ registros)",
		"search": "Buscar:",
		"infoThousands": ",",
		"loadingRecords": "Cargando...",
		"paginate": {
		"first": "Primero",
		"last": "Último",
		"next": "Siguiente",
		"previous": "Anterior"
		},
		"aria": {
		"sortAscending": ": Activar para ordenar la columna de manera ascendente",
		"sortDescending": ": Activar para ordenar la columna de manera descendente"
		},
		"buttons": {
		"copy": "Copiar",
		"colvis": "Visibilidad"
		}
	}  
});
require('select2');
require('select2/dist/js/i18n/es');
$.fn.select2.defaults.set('theme','bootstrap4');
$.fn.select2.defaults.set('language','es');

$(function() {
	// Select2

	$('.select2').not('.select2-delay').select2();

	// Flash
	
	$('#flash-overlay-modal').modal();
	$('div.alert').not('.alert-important').delay(4000).fadeTo(400,0.3);

	// Binding CyanButtons

	$('main').on('click', '.cyan-button', function() {
		var t = $(this);
		var e = t.attr('data-explanation');
		var a = t.attr('data-action');
		if (e && e != '') {
			if (!confirm('¿Confirma que desea ' + e + '?')) return;

		} 
		window['cyanButton_' + a](t);
		
	});
});

window.cyanDatatable = function(selector, params) {

	var me = $(selector).eq(0);

	var thead = me.find('thead');

	if (thead.is('.withFilter')) {

		var tr = thead.find('tr');

		var newTr = tr.clone(true).appendTo(thead);
		newTr.find('th').each(function(i) {
			var t = $(this);

			t.addClass('filterRow sorting_disabled');
			
			var title = t.text();

			if (t.is('.nofilter')) {
				t.text('');
				return;
			}

			var fv = t.attr('data-filterValues');
			var placeholder = t.attr('data-filterPlaceholder');
			if (!placeholder)
				placeholder = 'Filtrar ' + title;


			if (!fv) {

				t.html('<input type="text" class="filterInput" placeholder="' + placeholder + '" />');

				$('input', t).on('keyup change', function() {
					if (table.column(i).search() !== this.value) {
						table
							.column(i)
							.search(this.value)
							.draw();
					}
				});
	

			} else {

				t.html('<select class="filterSelect form-select"></select>');
				var s = t.find('select');


				$('<option value=""></option>').text(placeholder).appendTo(s);

				var p = fv.split('|');

				var current = 0;

				for (var n = 0; n < p.length; n++) {

					var text = p[n];
					var prefijo = text.match(/^[0-9]+:/);
					if (prefijo) {
						current = parseInt(prefijo[0].replace(':',''));
						text = text.substr(prefijo[0].length);
					} else {
						current++;
					}

					$('<option value="'+current+'"></option>')
						.text(text)
						.appendTo(s);
				}
				$('select', t).on('change', function() {
					if (table.column(i).search() !== this.value) {
						table
							.column(i)
							.search(this.value)
							.draw();
					}
				});

			}

		});
	}

	var table = me.DataTable($.extend({},{
		processing: true,
		serverSide: true,
		orderCellsTop: true,
		bAutoWidth: false,

	},params));

	return table;

}

global.moment = require('moment');

require('tempusdominus-bootstrap-4');

require('jquery-hotkeys');
require('bootstrap-wysiwyg');

window.cyanLeaflet = function(id, marcadores, forceFit) {

	var refreshing = false;

	if (id instanceof L.Map) {
		map = id;
		map.eachLayer(function(l) { if (!(l instanceof L.TileLayer)) map.removeLayer(l);})
		refreshing = true;
	} else {
		var map = L.map(id).setView([13.69850,-89.19104], 17);
		L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {
			attribution: '&copy; Autores de <a href="http://osm.org/copyright">OpenStreetMap</a>'
		    }).addTo(map);
	}


	var tiposMarcador = {
		apertura: {
			backgroundColor: '#070',
			icon: 'check'

		},
		cierre: {
			backgroundColor: '#700',
			icon: 'flag-checkered'
		},
		encuestadorApertura: {
			backgroundColor: '#001981',
			icon: 'check'

		},
		encuestadorCierre: {
			backgroundColor: '#001981',
			icon: 'flag-checkered'
		},
		recinto: {
			backgroundColor: 'orange',
			icon: 'home',
			innerIconStyle: 'font-size: 20px;position:relative;left:-2px;',
		},
		centro: {
			backgroundColor: 'orange',
			icon: 'home',
			innerIconStyle: 'font-size: 20px;position:relative;left:-2px;',
		},
		canopy: {
			backgroundColor: '#00abed',
			icon: 'bullhorn'

		},
		llegada: {
			backgroundColor: '#00abed',
			icon: 'thumbs-o-up'
		},
		encuestadorLlegada: {
			backgroundColor: '#001981',
			icon: 'hand-paper-o'
		},
		cyanLlegada: {
			backgroundColor: '#00abed',
			icon: 'thumbs-up'

		},
		default: {
			backgroundColor: '#00abed',
			icon: 'star'
		},
		'incidencia-1': {
			backgroundColor: '#f53d0f',
			icon: 'exclamation-circle'
		},
		'incidencia-2': {
			backgroundColor: '#d99c02',
			icon: 'question-circle'
		},
		'incidencia-3': {
			backgroundColor: '#969e95',
			icon: 'times-circle'
		},
		'incidencia-4': {
			backgroundColor: '#1a9e09',
			icon: 'check-circle'
		},
	}

	var icono = function(tipo) {

		var t = typeof tiposMarcador[tipo] === 'undefined' ? 'default' : tipo;

		return L.BeautifyIcon.icon(
			$.extend({
				iconShape: 'marker',
				borderWidth: 1,
				innerIconStyle: 'font-size: 20px;',
				borderColor: 'black',
				textColor: 'white',
				iconSize: [36, 36],
				iconAnchor: [18,36]

			},tiposMarcador[t])
		)
	}


	var markers = [];

	var cg = L.markerClusterGroup({
		maxClusterRadius: 25,
		animate: true
	});

	for(var n = 0; n != marcadores.length; n++) {
		var m = marcadores[n];
		var marker = L.marker([m.lat, m.lon], {icon: icono(m.tipo)}).bindPopup(
		(m.link ? '<a href="' + m.link + '">':'')
		+ "<b>" + m.header + '</b>'
		+ (m.link ? '&nbsp;<i class="fa fa-external-link" aria-hidden="true"></i></a>':'')
		+'<br />' + m.text);
		cg.addLayer(marker);
		markers.push(marker);

	}

	var group = new L.featureGroup(markers);
	if (!refreshing || forceFit)
		map.fitBounds(group.getBounds(), { padding: [50,50], maxZoom: 17 });
	map.addLayer(cg);

	return map;

}
